import { createSlice } from '@reduxjs/toolkit';

import { InquiryEntryType } from '@interfaces/inquiries';
import eventBus, { EventType } from '@utils/eventBus';

import {
  handleAdminDeactivateSupplement,
  handleAdminSupplementRenew,
  handleGetAdminMedicationDetails,
  handleGetAdminSupplementDetails,
} from './actions';
import { IAdminSupplementDetailsState } from './slice.interface';

const initialState: IAdminSupplementDetailsState = {
  activeId: null,
  activeEntryType: null,
  supplementDetails: null,
  medicationDetails: null,
  isLoading: false,
  isDeactivating: false,
  error: false,
};

export const inquiryEntryDetailsSlice = createSlice({
  name: 'admin-supplement-details',
  initialState,
  reducers: {
    removeAdminSupplementInquiryDetails: state => {
      state.activeId = null;
      state.activeEntryType = null;
      state.supplementDetails = null;
      state.medicationDetails = null;
      state.isLoading = false;
      state.error = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(
        handleGetAdminSupplementDetails.pending,
        (state: IAdminSupplementDetailsState, action) => {
          state.activeId = action.meta.arg;
          state.activeEntryType = InquiryEntryType.Supplement;
          state.supplementDetails = null;
          state.medicationDetails = null;
          state.isLoading = true;
          state.error = false;
        },
      )
      .addCase(handleGetAdminSupplementDetails.rejected, (state: IAdminSupplementDetailsState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(
        handleGetAdminSupplementDetails.fulfilled,
        (state: IAdminSupplementDetailsState, action) => {
          state.supplementDetails = action.payload.data;
          state.isLoading = false;
        },
      )
      .addCase(
        handleGetAdminMedicationDetails.pending,
        (state: IAdminSupplementDetailsState, action) => {
          state.activeId = action.meta.arg;
          state.activeEntryType = InquiryEntryType.Medication;
          state.supplementDetails = null;
          state.medicationDetails = null;
          state.isLoading = true;
          state.error = false;
        },
      )
      .addCase(handleGetAdminMedicationDetails.rejected, (state: IAdminSupplementDetailsState) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(
        handleGetAdminMedicationDetails.fulfilled,
        (state: IAdminSupplementDetailsState, action) => {
          state.medicationDetails = action.payload.data;
          state.isLoading = false;
        },
      )
      .addCase(handleAdminSupplementRenew.fulfilled, () => {
        eventBus.emit(EventType.ADMIN_RENEW_SUPPLEMENT_SUBMITTED);
      })
      .addCase(handleAdminDeactivateSupplement.pending, (state: IAdminSupplementDetailsState) => {
        state.isDeactivating = true;
      })
      .addCase(handleAdminDeactivateSupplement.rejected, (state: IAdminSupplementDetailsState) => {
        state.isDeactivating = false;
      })
      .addCase(handleAdminDeactivateSupplement.fulfilled, (state: IAdminSupplementDetailsState) => {
        state.isDeactivating = false;
        eventBus.emit(EventType.ADMIN_DEACTIVATE_SUPPLEMENT_SUCCESS);
      });
  },
});

export const { removeAdminSupplementInquiryDetails } = inquiryEntryDetailsSlice.actions;

export default inquiryEntryDetailsSlice.reducer;
